// extracted by mini-css-extract-plugin
export var tosLink = "_ap-0";